import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ShoppingCart, User, Package } from "lucide-react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const BottomNavigation = () => {
  const location = useLocation();
  const cartItemsCount = useSelector((state) => state.cart.cartProducts.length);
  const { t } = useTranslation();

  const navItems = [
    { name: t('navigation.home'), icon: Home, path: "/" },
    { name: t('navigation.orders'), icon: Package, path: "/orders" },
    { name: t('navigation.cart'), icon: ShoppingCart, path: "/cart" },
    { name: t('navigation.profile'), icon: User, path: "/profile" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-primary-50 shadow-lg dark:bg-background-100 dark:border-border-100 border">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`flex flex-col items-center justify-center w-full h-full ${
              location.pathname === item.path
                ? "text-primary-100"
                : "text-gray-500"
            }`}
          >
            <div className="relative flex flex-col items-center">
              <item.icon className="w-6 h-6" />
              <span className="text-xs mt-1">{item.name}</span>
              {item.name === t('navigation.cart') && cartItemsCount > 0 && (
                <span className="absolute -top-1 left-2 transform translate-x-4 bg-primary-100 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {cartItemsCount}
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavigation;
